var exports = {
  "kL": "SlowmodeIndicator.module__container___RGRCeG",
  "K2": "SlowmodeIndicator.module__cooldown___RGRCeG",
  "Pf": "SlowmodeIndicator.module__label___RGRCeG",
  "Kk": "SlowmodeIndicator.module__icon___RGRCeG",
};

module.exports = exports;
